import { useEffect, useRef, useState } from "react";
import { ApplyForm } from "./ApplyForm";
import { BookScreen } from "./BookScreen";
import { ResourcesScreen } from "./ResourcesScreen";

const EMPTY = { full_name: "", phone: "", email: "", stage: "", goal: "", invest: "", timeline: "" };

export const ApplyCard = () => {
  const [values, setValues] = useState(EMPTY);
  const [screen, setScreen] = useState("form");
  const cardRef = useRef(null);
  const first = useRef(true);

  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    const top = cardRef.current?.getBoundingClientRect().top ?? 0;
    if (window.innerWidth < 1024 || top < 0) {
      const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      cardRef.current?.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
    }
  }, [screen]);

  const back = () => setScreen("form");

  return (
    <div ref={cardRef} className="pearl-card fade-up scroll-mt-4 rounded-2xl px-5 py-7 text-[#17130c] shadow-[10px_10px_0_0_#e8b84a] [animation-delay:120ms] sm:px-9 sm:py-10" data-testid="apply-card" data-screen={screen}>
      {screen === "form" && <ApplyForm values={values} setValues={setValues} onDone={(invest) => setScreen(invest === "not" ? "resources" : "book")} />}
      {screen === "book" && <BookScreen name={values.full_name.trim()} email={values.email.trim()} onBack={back} />}
      {screen === "resources" && <ResourcesScreen onBack={back} />}
    </div>
  );
};
